var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-customer-service-preview"},[_c('img',{style:({height: `${_vm.$$FormData.image_size}px`,width:`${_vm.$$FormData.image_size}px`}),attrs:{"src":_vm.$$FormData.background_image.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }